export const NO_BITUAJ_RESULT_WARNING = 'NoInsuranceResultWarning';
export const APPLICANT_HAS_ANOTHER_APPLICATION_ERROR = 'ApplicantHasAnotherApplicationError';
export const LOGIN_CREDENTIALS_ERROR = 'InvalidCredentialsError';
export const SSO_SECURITY_PROVIDER_ERROR_NOT_MAPPED_ERROR = 'SecurityProviderErrorNotMappedError';
export const SSO_SECURITY_PROVIDER_UNKNOWN_ERROR = 'SecurityProviderUnknownError';
export const INSUFFICIENT_PRIVILEGES_ERROR = 'InsufficientPrivilegesError';
export const ACCESS_TOKEN_EXPIRED_ERROR = 'AccessTokenExpiredError';
export const SESSION_EXPIRED_ERROR = 'SessionExpiredError';
export const UNDEFINED_AUTHORIZATION_ERROR = 'UndefinedAuthorizationError';
export const UNDEFINED_ERROR = 'UndefinedError';
export const MAX_NUMBER_REQUEST_BUREAU_CODE_ERROR = 'MaxNumberRequestBureauCodeError';
export const ALREADY_SENT_NIP_CODE_MAX_ALLOWED_TIMES_ERROR = 'AlreadySentNipCodeMaxAllowedTimesError';
export const CREDIT_BUREAU_GATEWAY_ERROR = 'CreditBureauQueryFailedError';
export const NOT_ELIGIBLE_BY_CREDIT_BUREAU_ERROR = 'NotEligibleByCreditBureauError';
export const INVALID_NIP_CODE_ERROR = 'InvalidNipCodeError';
export const NIP_CODE_EXPIRED_ERROR = 'NipCodeExpiredError';
export const LOAN_APPLICATION_ALREADY_FINISHED_ERROR = 'LoanApplicationAlreadyFinishedError';
export const WSDL_BITUAJ_ERROR = 'WSDLBituajError';
export const LOAN_APPLICATION_UNAUTHORIZED_ACCESS_ERROR = 'LoanApplicationUnauthorizedAccessError';
export const USER_CLAIM_ERROR = 'UserClaimError';
export const AUTH_TOKEN_NOT_PROVIDED_ERROR = 'AuthTokenNotProvidedError';
export const TOKEN_VERIFICATION_ERROR = 'TokenVerificationError';
export const NOT_FOUND_LOCATION_ERROR = 'NotFoundLocationError';
export const TURBO_CASH_COMPLETED_LOAN_APPLICATION_ERROR = 'TurboCashCompletedLoanApplicationInvalidEditionError';
export const CIRCULO_CREDITO_LOG_REPOSITORY_NOT_FOUND_ERROR = 'CirculoCreditoLogRepositoryNotFoundError';
